<div class="empty">
  <div class="empty__icon" aria-hidden="true"><i [class]="'bx ' + icon()"></i></div>
  <h3 class="empty__title">{{ heading() }}</h3>
  @if (message()) {
    <p class="empty__msg">{{ message() }}</p>
  }
  <div class="empty__action"><ng-content select="[empty-action]" /></div>
</div>
